var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-pagination',{staticClass:"table-pagination flex-center",attrs:{"background":"","hide-on-single-page":_vm.singlePageHide,"current-page":_vm.currentPage,"page-size":_vm.pageSize,"pager-count":5,"prev-text":"上一页","next-text":"下一页","layout":"total, prev, pager, next","total":_vm.total},on:{"current-change":_vm.handleCurrentChange}})
}
var staticRenderFns = []

export { render, staticRenderFns }